import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { AllStatus } from '../../../../core/services/status/all-status';
import { FieldBuilder } from '../../../services/fields/field-builder';
import * as _ from "lodash";
import { environmentDev } from '../../../../../environments/environment.dev';
import { take } from 'rxjs';
import { Downtime } from '../../../../core/services/times/downtime';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { environmenProgress } from '../../../../../environments/environment.progress';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-difficulty-level',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions, MatProgressBarModule],
  templateUrl: './difficulty-level.html',
  styleUrl: './difficulty-level.scss'
})
export class DifficultyLevelComponent implements OnInit {

  readonly dialogRef = inject(MatDialogRef<DifficultyLevelComponent>);
  data = inject(MAT_DIALOG_DATA);
  allStatus = inject(AllStatus);
  field = inject(FieldBuilder);
  questInfo: any;
  pdfFiles:boolean = false;
  listFiles: any = [];
  downtime = inject(Downtime);
  configuration = inject(ConfigurationService);
  setProgress = environmenProgress;
  public settings = environment;

  ngOnInit(): void {
    // TODO allStatus.valueDifficulty().rqId - ще поки є таке значення
    this.questInfo = JSON.parse(sessionStorage.getItem('QuestInfo') as string);
    if(this.questInfo.data?.pdf_files){
      this.listFiles = _.isEmpty(this.questInfo.data?.pdf_files[this.allStatus.valueDifficulty().result.level]) ? [] : this.questInfo.data?.pdf_files[this.allStatus.valueDifficulty().result.level];
      this.pdfFiles = true;
      if(this.configuration.configuration.profile.nsp){
        this.filterNsp();
      }else{
        this.filterNotNsp();
      }
    }else{
      this.pdfFiles = false;
    }
    this.dialogRef.disableClose = true;
  }

  filterNsp(){
    const resF = this.listFiles.filter((item: any) => item.nsp === true );
    if(_.isEmpty(resF)){
      this.filterNotNsp();
    }else{
      this.listFiles = resF;
    }
  }

  filterNotNsp(){
    const resF = this.listFiles.filter((item: any) => item.nsp === false );
    if(_.isEmpty(resF)){
      this.pdfFiles = false;
    }else{
      this.listFiles = resF;
    }    
  }

  calcult(points: number = 0, maxPoints: number = 0): number{
    let res: number = (points / maxPoints) * 100;
    return parseFloat(res.toFixed(2))||0 ;
  }

  nameField(typeId: number){
    let result = this.field.findField(typeId);
    return (result?.title) ? result.title : '' ;
  }

  nameRQPlayer():string{
    return this.questInfo.data.humman_description.title || '';
  }

  titleNow(){
    let txtTitle = 'txtDefault';
    const resSearch = environmentDev.levelPDFTitle.find(item => item.level === this.allStatus.valueDifficulty().result.level);
    if(resSearch){
      txtTitle = resSearch.title;
    }
    return txtTitle;
  }

  newOpenLink(event: Event, url: string){
    event.preventDefault();
    this.allStatus.setDisplayProgressSpinner(true);
    this.downtime.refreshTimer();
    this.field.changeLinkPDF(url).pipe(
      take(1)
    ).subscribe((result: any)=>{
      this.allStatus.setDisplayProgressSpinner(false);
      window.open(result.url, '_blank');
    });
  }

  onNoClick(): void {
    this.downtime.refreshTimer();
   // this.allStatus.clearDataDifficulty();
    this.dialogRef.close();
  }

  clickIconClose(event: MouseEvent){
      this.onNoClick();
  }

  yourTxtRating(interest: number){
    let txt = 'txtEmpty';

    this.setProgress.ratings.forEach((item:any) => {
      if(item.valueB <= interest && interest <= item.valueE){
        txt = item.langT;
      }
    });

    return txt;
  }

}
